import { render, staticRenderFns } from "./CustomSelectField.vue?vue&type=template&id=3c15dd6e"
import script from "./CustomSelectField.vue?vue&type=script&lang=ts"
export * from "./CustomSelectField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports